(function () {
  const REVIEW_PAGE_URL = '/pages/reviews';

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.jdgm-carousel__left-arrow') ||
      e.target.closest('.jdgm-carousel__right-arrow') ||
      e.target.closest('.jdgm-carousel__arrows') ||
      e.target.closest('.jdgm-carousel-dot') ||
      e.target.closest('.jdgm-carousel__dot') ||
      e.target.closest('button') ||
      e.target.closest('a')
    ) {
      return;
    }

    const reviewItem = e.target.closest('.shopify-app-block .jdgm-carousel-item');
    const ratingWrapper = e.target.closest('.shopify-app-block .jdgm-all-reviews-rating-wrapper');

    if (reviewItem || ratingWrapper) {
      window.location.href = REVIEW_PAGE_URL;
    }
  });

  const style = document.createElement('style');
  style.innerHTML = `
    .shopify-app-block .jdgm-carousel-item,
    .shopify-app-block .jdgm-all-reviews-rating-wrapper {
      cursor: pointer;
    }
  `;
  document.head.appendChild(style);

const DAY_LIMIT = Number(window.reviews_limit) || 3;

function getReviewAgeInDays(dateStr) {
  if (!dateStr) return null;

  const parts = dateStr.split('/');
  if (parts.length !== 3) return null;

  const month = parseInt(parts[0], 10);
  const day = parseInt(parts[1], 10);
  const year = parseInt(parts[2], 10);

  if (!month || !day || !year) return null;

  const reviewDate = new Date(year, month - 1, day);
  const today = new Date();

  reviewDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  const diffTime = today.getTime() - reviewDate.getTime();
  return diffTime / (1000 * 60 * 60 * 24);
}

function processReviews() {
  const items = document.querySelectorAll('.jdgm-carousel-item');
  if (!items.length) return;

  const firstItem = items[0];
  const firstTimestampEl = firstItem.querySelector('.jdgm-carousel-item__timestamp');

  if (!firstTimestampEl) return;

  const firstDateStr = firstTimestampEl.getAttribute('data-time');
  const firstReviewAge = getReviewAgeInDays(firstDateStr);

  if (firstReviewAge === null) return;

  const showDates = firstReviewAge <= DAY_LIMIT;

  items.forEach((item) => {
    const timestampEl = item.querySelector('.jdgm-carousel-item__timestamp');
    if (!timestampEl) return;

    if (showDates) {
      item.classList.add('visible-date');
    } else {
      item.classList.remove('visible-date');
    }
  });
}





  // Run initially (in case already loaded)
  processReviews();

  // Observe dynamic loading (Judge.me async rendering)
  const observer = new MutationObserver(() => {
    processReviews();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });



})();
